<div [ngStyle]="{backgroundColor:item.data.bgColor,
             backgroundImage:addUrl(item.data.bgImage),
             backgroundSize:'cover',
             color:item.data.textColor,
             width:'100%',
             padding:cs.paddingString(item.data.spacing),
             margin:cs.marginString(item.data.spacing),
             borderWidth:cs.borderString(item.data.spacing),
             borderStyle:item.data.borderStyle.style,
             borderColor:item.data.borderStyle.color,
             textAlign:item.data.align}">
  <ng-content></ng-content>
</div>
